(function ($) {
    $(document).ready(function () {
        $('.jetpack-testimonial-shortcode').slick({
            dots: false,
            infinite: true,
            easing: 'swing',
            autoplay: true,
            autoplaySpeed: 6000,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false
        });
    });
})(jQuery);